import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import api from 'lib/api';
import { addError } from 'actions';
import { createAssessments, updateAssessment, updateAssessmentStatus } from 'actions/assessments';
import SimpleSelect from 'components/Inputs/SimpleSelect';
import AssessmentForm from 'containers/Forms/AssessmentForm';
import Modal from 'containers/Modals/Modal';
import ClearBlockAssessments from 'containers/Forms/Assessment/ClearBlockAssessments';
import swal from 'sweetalert2';
import { Spinner } from 'UI';
import { Checkbox, Icon, Button, translate } from '@haldor/ui';

var UserGroupAssignment = /*#__PURE__*/function (_Component) {
  _inherits(UserGroupAssignment, _Component);

  var _super = _createSuper(UserGroupAssignment);

  function UserGroupAssignment(props) {
    var _this;

    _classCallCheck(this, UserGroupAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "publishAllAssessments", function () {
      var _this$props = _this.props,
          addError = _this$props.addError,
          translate = _this$props.translate,
          assessments = _this$props.assessments;
      var tasks = _this.props.assignment.tasks;
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('publish-all-assessments-warning'),
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('yes-publish')
      }).then(function (result) {
        if (result.value != null) {
          var requests = 0;
          tasks.map(function (task) {
            if (task.status == 'ASSIGNMENT_TASK_SUBMITTED') {
              task.students.map(function (student) {
                var userAssessment = assessments.find(function (assessment) {
                  return assessment.referenceId == task.id && assessment.studentId == student.id;
                });

                if (userAssessment != null) {
                  if (userAssessment.status != 'ASSESSMENT_PUBLISHED') {
                    requests++;
                    api.put("assessments/status?assessmentId=".concat(userAssessment.id, "&status=ASSESSMENT_PUBLISHED"), null).then(function () {
                      requests--;

                      if (requests == 0) {
                        addError(translate('changes-saved'), 'info');

                        _this.props.reload(true);
                      }
                    });
                  }
                }
              });
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAssessment", function (skipPrompt) {
      if (skipPrompt) {
        _this.props.reload(true);

        _this.unselectAll();

        _this.setState({
          assessmentOpen: false
        });
      } else {
        _this.setState({
          assessmentOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openAssessment", function (task, user) {
      if (user != null) {
        _this.state.tasks.forEach(function (task) {
          task.students.forEach(function (student) {
            return student.selected = false;
          });
          return task;
        });

        user.selected = true;
      } else {
        _this.state.tasks.forEach(function (task) {
          task.students.forEach(function (student) {
            var assessment = _this.props.assessments.find(function (t) {
              return t.studentId == student.id;
            });

            if (assessment != null) {
              student.selected = false;
            }
          });
        });
      }

      _this.setState({
        assessmentOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      return new Promise(function (resolve) {
        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing).then(function () {
            resolve(1);

            _this.closeAssessment(true);
          });

          return true;
        }

        var data = [];
        var selectedStudents = [];

        _this.state.tasks.forEach(function (task) {
          task.students.forEach(function (student) {
            if (student.selected) {
              selectedStudents.push(_objectSpread({
                status: task.status,
                groupName: student.firstName + ' ' + student.lastName,
                assignedTo: student.userId
              }, student));
            }
          });
        });

        selectedStudents.forEach(function (student) {
          data.push(_objectSpread(_objectSpread({}, values), {}, {
            assignmentId: _this.props.assignment.id,
            referenceId: student.referenceId,
            studentId: student.userId
          }));
        });

        _this.props.createAssessments(data).then(function () {
          resolve(1);

          _this.closeAssessment(true);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", function (item, event) {
      item.disabled = true;

      _this.setState({});

      api.put('assignments/Student/Status?assignmentTaskId=' + item.id + '&status=' + event.value).then(function () {
        item.disabled = false;
        item.status = event.value;

        _this.setState({});

        _this.props.addError(_this.props.translate('changes-saved'), 'info');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentStatusSelect", function (item, value) {
      var assessment = _this.props.assessments.find(function (t) {
        return t.studentId == item.id;
      });

      if (assessment != null) {
        _this.props.updateAssessmentStatus(assessment.id, value.value).then(function () {
          _this.props.addError(_this.props.translate('changes-saved'), 'info');

          _this.props.reload(true);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (user, checked) {
      user.selected = checked;

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "markForConversation", function (task) {
      var student = task;

      if (_this.props.onConversation != null) {
        _this.props.onConversation(student);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLocked", function (locked) {
      var _this$props2, _this$props2$assignme;

      //get the task for the selected users
      var task = [];
      (_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$assignme = _this$props2.assignment) === null || _this$props2$assignme === void 0 ? void 0 : _this$props2$assignme.tasks.map(function (item) {
        return item.assignmentTaskAssignees.map(function (assignees) {
          if (locked) {
            if (assignees.permission === '5' || assignees.permission === '2') {
              task.push(assignees);
            }
          } else if (assignees.permission === '0') {
            task.push(assignees);
          }
        });
      });

      if (task.length > 0) {
        _this.setState({
          loadingPermission: true
        });

        var assignmentId = _this.props.assignment.id;

        if (locked) {
          api["delete"]("assignments/".concat(assignmentId, "/workspacepermissions"), task).then(function (response) {
            var _this$props3, _this$props3$assignme;

            (_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$assignme = _this$props3.assignment) === null || _this$props3$assignme === void 0 ? void 0 : _this$props3$assignme.tasks.map(function (item) {
              return item.assignmentTaskAssignees.map(function (assignees) {
                console.log(assignees);
                var findItem = response.data.find(function (x) {
                  return x.assigneeId == assignees.assigneeId;
                });

                if (findItem) {
                  assignees.permission = findItem.permission;
                }
              });
            });

            _this.onCheckAll(false);

            _this.setState({
              loadingPermission: false
            });

            return;
          })["catch"](function (e) {
            _this.setState({
              loadingPermission: false
            });

            _this.onCheckAll(false);
          });
          return;
        }

        api.put("assignments/".concat(assignmentId, "/workspacepermissions"), task).then(function (response) {
          var _this$props4, _this$props4$assignme;

          (_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : (_this$props4$assignme = _this$props4.assignment) === null || _this$props4$assignme === void 0 ? void 0 : _this$props4$assignme.tasks.map(function (item) {
            return item.assignmentTaskAssignees.map(function (assignees) {
              console.log(assignees);
              var findItem = response.data.find(function (x) {
                return x.assigneeId == assignees.assigneeId;
              });

              if (findItem) {
                assignees.permission = findItem.permission;
              }
            });
          });

          _this.onCheckAll(false);

          _this.setState({
            loadingPermission: false
          });

          return;
        })["catch"](function (e) {
          _this.setState({
            loadingPermission: false
          });

          _this.onCheckAll(false);
        });
      } else {
        _this.onCheckAll(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCheckAll", function (checked) {
      _this.state.tasks.forEach(function (task) {
        task.students.forEach(function (student) {
          var assessment = _this.props.assessments.find(function (t) {
            return t.studentId == student.id;
          });

          if (assessment != null) {
            student.selected = false;
          } else {
            student.selected = student.selected ? false : true;
          }
        });
      });

      _this.setState({
        assessTask: checked,
        allSelected: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unselectAll", function () {
      _this.state.tasks.forEach(function (task) {
        task.students.forEach(function (student) {
          student.selected = false;
        });
      });

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupBody", function () {
      var rootUrl = _this.props.activeSection.classroomUrl;
      var rootUri = new URL(rootUrl);
      var segments = rootUri.pathname.split('/');
      rootUrl = rootUrl.substring(0, rootUrl.indexOf('/' + segments[1] + '/'));
      return _this.state.tasks.map(function (item) {
        var disableAssessmentButtons = false;

        if (item.status == 'ASSIGNMENT_TASK_STARTED' || item.status == 'ASSIGNMENT_TASK_NOT_STARTED') {
          disableAssessmentButtons = true;
        }

        return /*#__PURE__*/React.createElement("tbody", {
          key: item.id
        }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
          className: "name",
          style: {
            fontSize: '1.15em'
          }
        }, item.groupName), /*#__PURE__*/React.createElement("td", {
          className: "status"
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          selectedValue: item.status,
          disabled: _this.props.printable || _this.props.assignment.created == '0001-01-01T00:00:00' || _this.state.locked || item.disabled,
          name: "statusSwitcher",
          item: item,
          type: "assignment",
          onChange: _this.onStatusSelect
        })), /*#__PURE__*/React.createElement("td", {
          className: "status"
        }), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.printable == true || item.disabled ? null : /*#__PURE__*/React.createElement("div", null, item.workspace ? /*#__PURE__*/React.createElement("a", {
          className: "sp-target-link",
          style: {
            marginTop: 0
          },
          href: rootUrl + item.workspace,
          target: "_blank"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Folder"
        }), /*#__PURE__*/React.createElement("span", null, " ".concat(_this.props.translate('workspace'))))) : /*#__PURE__*/React.createElement("div", {
          title: _this.props.translate('Missing-workspace')
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert_Red"
        }), /*#__PURE__*/React.createElement("span", null, " ".concat(_this.props.translate('workspace'))))))), item.students.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }).map(function (user) {
          var assessment = _this.props.assessments.find(function (t) {
            return t.studentId == user.id;
          });

          var conversation = null;

          if (_this.props.conversations != null) {
            conversation = _this.props.conversations.find(function (conv) {
              return conv.creator == user.id;
            });
          }

          var locked = (item === null || item === void 0 ? void 0 : item.assignmentTaskAssignees.filter(function (x) {
            return x.permission === '0' && x.assigneeId == user.id;
          }).length) > 0;
          return /*#__PURE__*/React.createElement("tr", {
            key: user.id,
            className: "no-hover"
          }, /*#__PURE__*/React.createElement("td", null, _this.props.printable == false ? /*#__PURE__*/React.createElement(Checkbox, {
            disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.state.locked || disableAssessmentButtons,
            label: /*#__PURE__*/React.createElement("span", {
              style: {
                marginLeft: '1rem'
              }
            }, locked ? /*#__PURE__*/React.createElement(Icon, {
              name: "Lock"
            }) : null),
            value: user.selected,
            onChange: function onChange(checked) {
              return _this.onSelect(user, checked);
            }
          }) : null), /*#__PURE__*/React.createElement("td", {
            className: "name"
          }, user.firstName, " ", user.lastName), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
            className: "status"
          }, /*#__PURE__*/React.createElement(SimpleSelect, {
            selectedValue: assessment === null || assessment === void 0 ? void 0 : assessment.status,
            name: "assessment-status",
            disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.printable == true || _this.state.locked || assessment == null,
            item: user,
            type: "assessment",
            onChange: _this.onAssessmentStatusSelect
          })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
            className: "make_assessment"
          }, _this.props.printable == false ? /*#__PURE__*/React.createElement(Button, {
            disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.state.locked || disableAssessmentButtons || item.disabled,
            type: "secondary",
            onClick: function onClick() {
              return _this.openAssessment(item, user);
            }
          }, _this.props.translate('assess')) : null), _this.props.services.conversations ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
            style: {
              cursor: 'pointer'
            },
            onClick: function onClick(e) {
              return _this.markForConversation(user);
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: '1.75rem',
              position: 'relative'
            }
          }, conversation != null ? /*#__PURE__*/React.createElement(Icon, {
            name: "Message"
          }) : /*#__PURE__*/React.createElement(Icon, {
            name: "Message",
            bw: true
          }), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
            className: "badge"
          }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null))) : null);
        }));
      });
    });

    _this.state = {
      assessmentOpen: false,
      tasks: [],
      locked: false,
      removeAssessments: false,
      assessTask: null,
      taskState: _this.props.assignment,
      allSelected: false,
      loadingPermission: false
    };
    return _this;
  }

  _createClass(UserGroupAssignment, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.parseGroups(null);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.assignment != this.props.assignment || nextProps.assignment.locked) {
        this.parseGroups(nextProps);
      }
    }
  }, {
    key: "parseGroups",
    value: function parseGroups(nextProps) {
      var _this2 = this;

      var assignment = null;

      if (nextProps != null) {
        assignment = nextProps.assignment;
      } else {
        assignment = this.props.assignment;
      }

      var tasks = [];
      assignment.tasks.forEach(function (item) {
        if (item != null && item.assignedTo != null) {
          if (item.id != -1) {
            var assignedUsers = item.assignedTo.split(';');
            var students = [];
            assignedUsers.forEach(function (user) {
              var findStudent = _this2.props.activeSection.students.find(function (t) {
                return t.id == user;
              });

              if (findStudent != null) {
                findStudent.referenceId = item.id;
                students.push(findStudent);
              }
            });
            students.sort(function (a, b) {
              if (a.lastName != null && b.lastName != null) {
                return a.lastName.localeCompare(b.lastName);
              }

              return 0;
            });
            var task = item;
            task.students = students;
            tasks.push(task);
          }
        }
      });
      this.setState({
        tasks: tasks,
        locked: assignment.locked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var selectedStudents = [];
      this.state.tasks.forEach(function (task) {
        task.students.forEach(function (student) {
          if (student.selected) {
            selectedStudents.push(_objectSpread({
              status: task.status,
              groupName: student.firstName + ' ' + student.lastName,
              assignedTo: student.userId
            }, student));
          }
        });
      });
      var unpublishedAssessment = this.props.assessments.find(function (ass) {
        return ass.status != 'ASSESSMENT_PUBLISHED';
      });
      var disableAssessmentsButton = true;

      if (unpublishedAssessment != null) {
        disableAssessmentsButton = false;
      }

      var assessAllButtonError = false;
      var disableRemoveAssessmentButton = true;
      selectedStudents.map(function (student) {
        if (student.status == 'ASSIGNMENT_TASK_STARTED' || student.status == 'ASSIGNMENT_TASK_NOT_STARTED') {
          assessAllButtonError = true;
        }

        var hasAssessment = _this3.props.assessments.findIndex(function (assessment) {
          return assessment.studentId == student.userId;
        });

        if (hasAssessment > -1) {
          assessAllButtonError = true;
          disableRemoveAssessmentButton = false;
        }
      });
      var assessmentBlocks = null;
      var assessment = null;

      if (this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      if (selectedStudents.length == 1 && this.props.assessments != null) {
        assessment = this.props.assessments.find(function (assessment) {
          return assessment.studentId == selectedStudents[0].userId;
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.assessmentOpen,
        onClose: this.closeAssessment,
        title: this.props.translate('Assessment')
      }, /*#__PURE__*/React.createElement(AssessmentForm, {
        onClose: this.closeAssessment,
        onSubmit: this.onAssessmentSubmit,
        items: selectedStudents.map(function (selected) {
          return _objectSpread({
            firstname: selected.groupName
          }, selected);
        }),
        blocks: assessmentBlocks,
        referenceType: "AssignmentTask",
        initialValues: assessment
      })), /*#__PURE__*/React.createElement(Modal, {
        overridePrompt: true,
        isOpen: this.state.removeAssessments,
        type: "small",
        title: this.props.translate('Remove assessments'),
        onClose: function onClose() {
          return _this3.setState({
            removeAssessments: false
          });
        }
      }, /*#__PURE__*/React.createElement(ClearBlockAssessments, {
        items: selectedStudents.map(function (x) {
          return {
            assignedTo: x.assignedTo,
            groupName: x.groupName
          };
        }),
        assessments: this.props.assessments,
        section: this.props.activeSection,
        onAbort: function onAbort(reload) {
          if (reload) _this3.props.reload(true);

          _this3.setState({
            removeAssessments: false
          });
        }
      })), /*#__PURE__*/React.createElement("table", {
        className: "status-list"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        style: {
          padding: '1em 1.5em'
        }
      }, this.props.printable == true || this.props.assignment.created == '0001-01-01T00:00:00' || this.state.locked ? null : /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(event) {
          return _this3.onCheckAll(event);
        },
        value: this.state.allSelected
      })), /*#__PURE__*/React.createElement("th", null, this.props.translate('name')), /*#__PURE__*/React.createElement("th", null, this.props.translate('status')), /*#__PURE__*/React.createElement("th", null, this.props.translate('assessment-status')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null))), this.renderGroupBody()), !this.props.printable ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
        disabled: selectedStudents.length == 0 ? true : false,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this3.handleLocked(true);
        }
      }, this.state.loadingPermission ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('lock assignment')), /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.loadingPermission || selectedStudents.length == 0 ? true : false,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this3.handleLocked();
        }
      }, this.state.loadingPermission ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('unlock assignment'))) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: selectedStudents.length == 0 || this.props.assignment.created == '0001-01-01T00:00:00' || this.state.locked || assessAllButtonError,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this3.openAssessment();
        }
      }, this.props.translate('assess-selected-students')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || disableAssessmentsButton,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this3.publishAllAssessments();
        }
      }, this.props.translate('publish-assessments')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: disableRemoveAssessmentButton || this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || this.state.loading,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this3.setState({
            removeAssessments: true
          });
        }
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('Remove assessments')) : null);
    }
  }]);

  return UserGroupAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    assessments: state.assessments.assessments,
    conversations: state.Conversation.referenceConversations,
    activeSection: state.assignments.section,
    translate: translate(state.Languages.translations),
    blocks: state.Blocks.reference
  };
}

export default connect(mapStateToProps, {
  addError: addError,
  createAssessments: createAssessments,
  updateAssessment: updateAssessment,
  updateAssessmentStatus: updateAssessmentStatus
})(UserGroupAssignment);